export default __webpack_public_path__ + "static/media/gallery39.43fb3fb7.webp";